import React from 'react';
import MinAndMaxLength from './common/MinAndMaxLength'; 
function TextColumnConfig(props) {
    return (
        <React.Fragment>
            <MinAndMaxLength {...props} />
        </React.Fragment>
    );
}

export default TextColumnConfig;
